// extracted by mini-css-extract-plugin
export var container = "_gl-1";
export var editor = "_gl-2";
export var resizable = "_gl-3";
export var wrapper = "_gl-0";